import React from 'react';

// Default svg import resolves to the asset URL in this webpack config (not a
// React component), and the SSR bundle has no SVGR ReactComponent export — so
// render it as an <img> (works in both client and server builds).
import logoUrl from './assets/logo.svg';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className }) => (
  <img src={logoUrl} alt="Marble" className={className} />
);

export default Logo;
